/* Ekstra Halloween-design (Gresskar, Zombie og gresskar) — tillegg til br-banner-render.js, samme stil som «Zombie».
   Illustrasjonene er egne (Recraft) 4368 × 1344 px på Shopify CDN. Lastes før designeren, i handlekurven og i trykkskriptet. */
(function (root) {
  const CDN = 'https://cdn.shopify.com/s/files/1/0526/7419/9720/files/';
  function bg(url, iw, ih, W, H, b) {
    const href = root.BannerRender.asset ? root.BannerRender.asset(url) : url, bw = W + 2*b, bh = H + 2*b, ar = iw / ih;
    let w = bw, h = bw / ar; if (h < bh) { h = bh; w = bh * ar; }
    return `<image href="${href}" xlink:href="${href}" x="${-b + (bw - w)/2}" y="${-b + (bh - h)/2}" width="${w}" height="${h}" preserveAspectRatio="none"/>`;
  }
  const NYE = {
    halloween_gresskar: {
      name: 'Gresskar', swatch: '#E8822A', font: 'creepster', art: { iw: 4368, ih: 1344 },
      colors: { l1: '#C8F169', l2: '#F2F2E6' },
      photo: { cx: 44, cy: 50, r: 26, ring: '#C8F169' },
      box: { photo: [80, 14, -96, 86], none: [18, 14, -96, 86] },
      url: CDN + 'banner-halloween-gresskar.jpg?v=1792948989'
    },
    halloween_zombiegresskar: {
      name: 'Zombie og gresskar', swatch: '#123A33', font: 'creepster', art: { iw: 4368, ih: 1344 },
      colors: { l1: '#C8F169', l2: '#F2F2E6' },
      photo: { cx: 146, cy: 50, r: 22, ring: '#C8F169' },
      box: { photo: [172, 14, -104, 86], none: [122, 14, -104, 86] },
      url: CDN + 'banner-halloween-zombie-gresskar.jpg?v=1792948990'
    }
  };
  function patch(BR) {
    if (!BR || BR.__hw2) return BR;
    BR.__hw2 = true;
    Object.keys(NYE).forEach(id => {
      const d = NYE[id], url = d.url;
      BR.DESIGNS[id] = Object.assign({}, d, { draw(W, H, u, b) {
        return `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#0E2224"/>` + bg(url, d.art.iw, d.art.ih, W, H, b);
      } });
      delete BR.DESIGNS[id].url;
    });
    return BR;
  }
  if (root.BannerRender) patch(root.BannerRender);
  else {
    const prev = Object.getOwnPropertyDescriptor(root, 'BannerRender');
    let v;
    Object.defineProperty(root, 'BannerRender', { configurable: true, enumerable: true,
      get() { return prev && prev.get ? prev.get() : v; },
      set(x) { v = patch(x); if (prev && prev.set) prev.set(v); } });
  }
})(typeof window !== 'undefined' ? window : globalThis);